<template>
  <div class="app-container">
    <wizard-renderer ref="editor" :definition="createDefinition()" @done="handleDone" />
  </div>
</template>

<script>
import WizardRenderer from '@/components/DSE/WizardRenderer';
import { getDefinition } from '@/pages/planning/wizard/selectionWizardForm';
export default {
  components: {
    WizardRenderer
  },
  computed: {
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm(this.$i18n.t('common.close_warning'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleDone(value) {
      this.$emit('done', value);
    },
    createDefinition() {
      return getDefinition(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.reference-wrapper {
  display: inline-block;
}
</style>
